import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '../Modal';
import AdditionalInformationComun from './Action7/AdditionalInformationComun';
import AdditionalInformationRecharge from '../AdditionalInformationFileRecharge/AdditionalInformationFileRecharge';

interface IProp {
  proposal: any;
}
const CheckDocumentsAdditionalInformation = ({ proposal }: IProp) => {

    const checkDocuments = async () => {
        if((proposal?.proposalType?.name ?? '') === 'Solar Direct'){
            if((proposal.proposalAttachment?.length ?? 0) === 1){
                Modal.show({
                    title: "Informações Adicionais",
                    body: <AdditionalInformationComun proposal={proposal} isAccept={false} />,
                    showCancel: true,
                    showConfirm: false
                });
            }
        } 

        if((proposal?.proposalType?.name ?? '') === 'Enerzee Recharge'){
            if((proposal.proposalAttachment?.length ?? 0) <= 1){
                Modal.show({
                    title: "Documentos Adicionais",
                    body: <AdditionalInformationRecharge proposal={proposal}/>,
                    showCancel: true,
                    showConfirm: false
                });
            }
        } 
    }
    useEffect(() => {
        checkDocuments();
    }, []);

    return (
        <>
        </>
    )
};

export default CheckDocumentsAdditionalInformation;
